import { render, staticRenderFns } from "./Compatibility.vue?vue&type=template&id=57e4f8b1&scoped=true"
import script from "./Compatibility.vue?vue&type=script&lang=js"
export * from "./Compatibility.vue?vue&type=script&lang=js"
import style0 from "./Compatibility.vue?vue&type=style&index=0&id=57e4f8b1&prod&scoped=true&lang=css"
import style1 from "./Compatibility.vue?vue&type=style&index=1&id=57e4f8b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4f8b1",
  null
  
)

export default component.exports